import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { UpdateLeanModalState } from "../../../Store";
import { AdminButton } from "../../../../../SharedComponents/ListView";

export default function LeanModalButton({ inventory }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const openModal = () => dispatch(UpdateLeanModalState({ isVisible: true, inventory }));

  return (
    <AdminButton variant="primary" onClick={openModal}>
      {t("orientation")}
    </AdminButton>
  );
}
